import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_IddActivitySuppPlan = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_IddActivitySuppPlan' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>(Use as much space as necessary)</h3></p>

                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Outcome Statement</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>List the support activities for each desired outcome</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Support Instructions</span>
                            <span className='small'>Describe how supports need to be tailored to the person's preferences and profile</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>How often or by when?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtOutcome' name='txtOutcome' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtActivities' name='txtActivities' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtSupport' name='txtSupport' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtNameHow' name='txtNameHow' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtOutcome1' name='txtOutcome1' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtActivities1' name='txtActivities1' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtSupport1' name='txtSupport1' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtNameHow1' name='txtNameHow1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtOutcome2' name='txtOutcome2' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtActivities2' name='txtActivities2' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtSupport2' name='txtSupport2' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtNameHow2' name='txtNameHow2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtOutcome3' name='txtOutcome3' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtActivities3' name='txtActivities3' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtSupport3' name='txtSupport3' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtNameHow3' name='txtNameHow3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtOutcome4' name='txtOutcome4' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtActivities4' name='txtActivities4' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtSupport4' name='txtSupport4' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txtNameHow4' name='txtNameHow4' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Questions/Things to Figure Out</h3></p>
                <p className='w-750'><h4>(use as many lines as necessary)</h4></p>

                <table>
                    <tr>
                        <td className='w-20'></td>
                        <td className='w-380'>
                            <span className='eleHeader'>Person Responsible:</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>By When:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>1: </td>
                        <td className='w-380'>
                            <input type='text' id='txtPerson' name='txtPerson' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtWhen' name='txtWhen' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>2: </td>
                        <td className='w-380'>
                            <input type='text' id='txtPerson1' name='txtPerson1' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtWhen2' name='txtWhen2' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Signatures</h4></p>

                <table>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Person:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Legal Representative:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-400'></td>
                        <td className='signature w-300'></td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Provider Signature/Credentials:</td>
                        <td className='small w-300'>Date:</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











